/*
  AYO drag to scroll: every sideways row (products, collections, reviews, chips) can be
  dragged with the mouse the same way a finger swipes it on a phone. This also makes the
  rows movable inside the theme editor preview. Touch keeps the phone's own swipe.
  Loaded from snippets/ayo-global-deps.liquid. Add data-ayo-no-drag to opt a row out.
*/
(function () {
  if (window.__ayoDrag) return;
  window.__ayoDrag = true;

  const SKIP = 'input, textarea, select, option, label, [contenteditable], [data-ayo-no-drag], .ayo-no-drag';
  let drag = null;

  const scrollerFrom = (el) => {
    while (el && el !== document.body && el.nodeType === 1) {
      if (el.scrollWidth > el.clientWidth + 1) {
        const ox = getComputedStyle(el).overflowX;
        if (ox === 'auto' || ox === 'scroll') return el;
      }
      el = el.parentElement;
    }
    return null;
  };

  document.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest(SKIP)) return;
    const box = scrollerFrom(e.target);
    if (!box) return;
    drag = { box, x: e.clientX, left: box.scrollLeft, moved: false, lastX: e.clientX, lastT: e.timeStamp, v: 0, snap: '' };
  });

  document.addEventListener('pointermove', (e) => {
    if (!drag || e.pointerType !== 'mouse') return;
    const dx = e.clientX - drag.x;
    if (!drag.moved) {
      if (Math.abs(dx) < 6) return;
      drag.moved = true;
      drag.snap = drag.box.style.scrollSnapType;
      drag.box.style.scrollSnapType = 'none';
      drag.box.style.scrollBehavior = 'auto';
      document.documentElement.classList.add('ayo-dragging');
    }
    drag.box.scrollLeft = drag.left - dx;
    const dt = e.timeStamp - drag.lastT;
    if (dt > 0) drag.v = (e.clientX - drag.lastX) / dt;
    drag.lastX = e.clientX;
    drag.lastT = e.timeStamp;
    e.preventDefault();
  });

  const end = () => {
    if (!drag) return;
    const d = drag;
    drag = null;
    if (!d.moved) return;
    document.documentElement.classList.remove('ayo-dragging');
    // Glide on a little in the direction of the flick, then let the row settle on a card.
    const target = d.box.scrollLeft - d.v * 180;
    d.box.style.scrollSnapType = d.snap;
    d.box.style.scrollBehavior = '';
    d.box.scrollTo({ left: target, behavior: 'smooth' });
    // A drag must not open the product or link it started on.
    const stop = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
    window.addEventListener('click', stop, { capture: true, once: true });
    setTimeout(() => window.removeEventListener('click', stop, { capture: true }), 0);
  };
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
  window.addEventListener('blur', end);

  // Stop the browser from picking up a photo or link as a file while dragging a row.
  document.addEventListener('dragstart', (e) => { if (e.target.closest && !e.target.closest(SKIP) && scrollerFrom(e.target)) e.preventDefault(); });

  const css = document.createElement('style');
  css.textContent = 'html.ayo-dragging, html.ayo-dragging * { cursor: grabbing !important; user-select: none !important; -webkit-user-select: none !important; }';
  document.head.appendChild(css);
})();
